import React from 'react'
import './TinyTag.css'

export default function TinyTag({tagName}) {
  return (
    <div className='tinyTag'>
      {tagName}
    </div>
  )
}
